import { useEffect } from "react";
import { useNavigate } from "react-router";

export function Guidepage() {
  useEffect(() => {
    window.location.href =
      "https://splendid-tuberose-a37.notion.site/HANZAN-Guideline-989ae6831bf7416688d4375c78e7bf1d";
  }, []);

  return <></>;
}
